import useCurrentScreen from './useCurrentScreen'

export default useCurrentScreen
